import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { OrderCardContext } from '../../../../../contexts/card/cardOrder/context';
import ModalBodyLayout from '../partials/MainBodyLayout';
import { Button, Typography } from '../../../../../components';
import Alert from '../../../../../components/Alert';

const TopUpProcessing = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const { state } = useContext(OrderCardContext);

  const screenOptions = state?.screenOptions;
  const { wallet, ledgerAccount } = screenOptions;

  const openTransactionHistory = () => {
    history.push(`/dashboard/accounts/${wallet?.coin}/details`, {
      ledgerAccount,
      wallet,
    });
  };

  const renderFooter = () => (
    <div className="btn-container">
      <Button variant="primary" className="w-100" onClick={openTransactionHistory}>
        {translate('transaction_processed_button_label')}
      </Button>
    </div>
  );

  return (
    <ModalBodyLayout>
      <div className="mx-auto">
        <div className="text-center mt-5">
          <img className="w-50 mb-2" src="./assets/images/transaction-success.svg" alt="Success" />
        </div>
        <div className="text-center mt-4">
          <Typography variant="base" className="text-dark">
            {translate('transaction_processed_title')}
          </Typography>
        </div>
        <div className="text-center mt-4">
          <Typography variant="base" className="text-shadow">
            {translate('transaction_processed_subtitle')}
          </Typography>
        </div>
        <div className="w-100 mt-4 p-0">
          <Alert icon="info" type="info">
            <Typography as="span">{translate('transaction_processed_note')}</Typography>
          </Alert>
        </div>
      </div>
      {renderFooter()}
    </ModalBodyLayout>
  );
};

export default TopUpProcessing;
